import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';

class PrivacyStatement extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'PrivacyStatement');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    render() {
        return (
            <MBack title='隐私协议'>
                <div style={{ marginTop: 48, marginBottom: 48, paddingLeft: 8, paddingRight: 8, color: '#0D0D0D' }}>
                    隐私政策<br />
                    <br />
                    更新日期：2021年5月7日<br />
                    <br />
                    【前言】欢迎使用“播球帝直播”提供的服务！播球帝直播（指播球帝直播网站、播球帝直播客户端应用程序及对应的服务，以下称“播球帝直播”或简称“我们”）深知个人信息对您的重要性，我们一向庄严承诺保护使用我们产品和服务的用户（以下统称“用户”或“您”）的个人信息及隐私安全。您在使用播球帝直播时，我们可能会收集和使用您的相关个人信息。我们希望通过《隐私政策》（以下简称“本政策”）向您说明我们在收集和使用您相关个人信息时对应的处理规则等相关事宜，以便更好的保障您的权益。<br />
                    <br />
                    <br />
                    目录<br />
                    一、我们如何收集和使用个人信息<br />
                    <br />
                    二、我们如何使用COOKIES或同类技术<br />
                    <br />
                    三、我们可能分享、转让和披露的个人信息<br />
                    <br />
                    四、我们如何储存个人信息和保护个人信息<br />
                    <br />
                    五、如何管理您的个人信息<br />
                    <br />
                    六、第三方服务<br />
                    <br />
                    七、未成年人保护<br />
                    <br />
                    八、通知和修订<br />
                    <br />
                    九、联系我们<br />
                    <br />
                    <br />
                    <br />
                    一、我们如何收集和使用个人信息<br />
                    <br />
                    我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息：<br />
                    <br />
                    1.1我们将通过以下途径收集和获得您的个人信息：<br />
                    <br />
                    1.1.1您提供的信息。 例如：<br />
                    <br />
                    （1）您在注册播球帝直播的帐号或使用播球帝直播时，向我们提供的信息；<br />
                    <br />
                    （2）您通过播球帝直播向其他方提供的共享信息，以及您使用播球帝直播时所储存的信息。<br />
                    <br />
                    请注意，如您在播球帝直播服务中其他用户可见的公开区域内上传或发布的信息中、您对其他人上传或发布的信息作出的回应中公开您的信息，该等信息可能会被他人收集并加以使用。当您发现他人不正当地收集或使用您的信息时，可通过本政策“联系我们”章节所列的反馈渠道联系我们。<br />
                    <br />
                    1.1.2其他方分享的您的信息。亦即其他方使用播球帝直播时所提供有关您的共享信息。<br />
                    <br />
                    1.1.3我们获取的您的信息。您在使用播球帝直播时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息。<br />
                    <br />
                    1.2我们会出于以下目的，收集和使用您以下类型的个人信息：<br />
                    <br />
                    1.2.1帮助您完成注册及登录、身份认证<br />
                    <br />
                    为便于我们为您提供服务，您需要提供手机号码来进行注册或登录，并创建您的账号、用户名和密码。在您访问我们应用程序或网站时，虽然您可匿名浏览、搜索，但您需要注册成为平台用户后才能使用发布、评论及其他用户服务。<br />
                    <br />
                    如果您提供以下额外信息，将有助于我们给您提供更优的服务体验：您的头像、个人简介。但如果您不提供这些信息，并不会影响您使用播球帝直播的基本功能。<br />
                    <br />
                    在您使用身份认证的功能或服务时，根据相关法律法规，您可能需要提供您的真实身份信息（真实姓名、身份证号码、电话号码）以完成实名验证，特别且必要情况下基于安全考虑，为了确保我们为您本人提供服务，我们可能会根据您提供的信息进行校验，将通过“人脸识别”的方式验证您的身份。 这些信息属于个人敏感信息，您可以拒绝提供，但您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。<br />
                    <br />
                    同时，我们也提供注册账号的注销功能，在符合服务协议约定条件及国家相关法律法规规定的情况下，您可以自行在“注销账号”页面按照相应的要求（例如，您可以在播球帝直播安卓客户端“我的—账号安全—账户注销”，进入注销页面）提交注册账号注销申请。<br />
                    <br />
                    在您的播球帝直播账号注销之后，我们将立即停止为您提供播球帝直播服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。<br />
                    <br />
                    1.2.2维护基础功能的正常运行<br />
                    <br />
                    为向您提供更契合您需求的页面展示、了解产品适配性、识别账号异常状态、保障服务运营质量及效率，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：<br />
                    <br />
                    （1）日志信息：当您使用我们的客户端或网站提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的登录账号、筛选内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、关注、收藏及分享。<br />
                    <br />
                    （2）设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（例如IP地址）。<br />
                    <br />
                    同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用播球帝直播服务。
                    <br />
                    请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。<br />
                    <br />
                    1.2.3帮助您完成下单、支付并向您交付商品或服务
                    <br />
                    （1）如您在我们的服务过程中产生支付结算，您可以选择我们的关联方或与我们合作的第三方支付机构（包括目前Apple Pay等支付通道，以及在后续合作中的支付通道，以下称“支付机构”）所提供的支付服务。支付服务过程中我们可能需要将您的播球帝直播订单号与交易金额信息同这些支付机构共享以实现其确认您的支付指令并完成支付。<br />
                    <br />
                    （2）为展示您账户的订单信息及保障您的售后权益，我们会收集您在使用播球帝直播过程中产生的订单信息（例如您所充值金额、具体订单号、订单创建时间）、交易和消费记录、充值余额用于向您展示及便于您对订单进行管理。如发生交易提款情形的，我们可能会要求您提供您的身份信息、银行账号信息，包括银行卡信息、支付宝、微信支付第三方账号信息用于为您处理充值请求。<br />
                    <br />
                    （3）为完成订单支付、交付商品或服务、确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的支付机构等收集与交易进度相关的您的账号、订单、交易、支付信息，并将您的上述交易、支付信息共享给相关的上述服务提供者。
                    <br />
                    1.2.4向您提供资讯浏览互动与发布服务<br />
                    <br />
                    1.2.4.1 播球帝直播可能会向您推荐更感兴趣的信息，为实现这一功能，我们可能会收集必要的日志信息。<br />
                    <br />
                    1.2.4.2 用于信息展示的日志信息包括：<br />
                    <br />
                    a. 您操作、使用的行为信息：点击、关注、收藏、搜索、查询、浏览、下载、分享、交易<br />
                    <br />
                    b. 您主动提供的信息：反馈、发布、点赞、评论、编辑、性别、生日、地区、介绍<br />
                    <br />
                    c. 地理位置信息：GPS信息、WLAN接入点、蓝牙和基站等传感器信息<br />
                    <br />
                    1.2.4.3 GPS地理位置是敏感个人信息，若您拒绝提供，我们将不会根据GPS信息向您推荐信息，且不会影响播球帝直播其他功能的正常使用。<br />
                    <br />
                    1.2.4..4 我们会基于IP地址对应的城市向您展示、推荐您所在地区的本地相关信息。<br />
                    <br />
                    1.2.4.5 我们收集、使用的上述信息进行了去标识化处理，数据分析仅对应特定的、无法直接关联您身份的编码，不会与您的真实身份相关联。<br />
                    <br />
                    1.2.4.6发布与互动<br />
                    <br />
                    a.您发布内容、评论、提问或回答时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容。<br />
                    <br />
                    <br />
                    <br />
                    b.您使用上传图片、发布音视频功能时，我们会请求您授权相机、相册（存储空间）、照片、麦克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用播球帝直播的其他功能。<br />
                    <br />
                    c.您发布信息并选择显示位置时，我们会请求您授权地理位置权限，并收集与本服务相关的位置信息。您如果拒绝授权提供精确地理位置信息，将无法使用此功能，但不影响您正常使用播球帝直播的其他功能。<br />
                    <br />
                    d.请注意，您公开发布的信息中可能会涉及用户或他人的个人信息，若您公开发布的信息中包含他人个人信息的，在上传发布之前，您需确保为法律法规允许使用或已获得合法授权。<br />
                    <br />
                    1.2.5为您提供客服或其他用户响应功能<br />
                    <br />
                    当您联系我们的客服或使用其他用户响应功能时（例如提出售中售后申请、个人信息保护投诉或建议、其他客户投诉和需求），我们可能需要您提供必要的个人信息以匹配并核验您的用户身份，以便保障您的账号与系统安全。我们可能还会保存您的联系方式（您与我们联系时使用的或您向我们主动提供的其他联系方式）、您与我们的通信/通话记录和内容、与您需求相关联的其他必要信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。<br />
                    <br />
                    1.2.6我们通过间接方式收集到的您的个人信息：<br />
                    <br />
                    我们可能从关联方、第三方合作伙伴获取您授权共享的相关个人信息。例如，我们可能从第三方获取您授权共享的账号信息（昵称以及您授权的其他信息）并在您同意本隐私政策后将您的第三方账户与您的播球帝直播账户绑定，使您可以通过第三方账户直接登录并使用播球帝直播服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定收集并使用您的这些个人信息。<br />
                    <br />
                    1.2.7为您提供安全保障<br />
                    <br />
                    为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或播球帝直播相关协议规则的情况。我们可能会收集、使用或整合您的帐号信息、交易信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。<br />
                    <br />
                    1.2.8改进我们的服务<br />
                    <br />
                    我们可能将通过某一项播球帝直播服务所收集的个人信息，用于我们的其他服务。例如，在您使用某一项播球帝直播时所收集的您的个人信息，可能在另一项播球帝直播中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关播球帝直播的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的个人信息用于软件更新。<br />
                    <br />
                    1.2.9其他用途<br />
                    <br />
                    您了解并同意，在收集您的个人信息后，如果我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用，而无需另行获得您的同意。
                    <br />
                    请您注意，如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会通过页面提示、交互流程、网站公告或其他方式另行征得您的同意。一旦您同意，该等额外用途将视为本政策的一部分，该等额外信息也将适用本政策。
                    <br />
                    1.2.10您理解并同意，部分单项服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及信息的收集和使用。例如：<br />
                    <br />
                    （1）在您开启相册和/或相机（摄像头）权限后，您能够上传、拍摄照片/图片，实现上传头像或与客服沟通提供证明等功能；您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用播球帝直播的其他功能。
                    <br />
                    当您需要关闭这些功能权限时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。<br />
                    <br />
                    1.2.11征得授权同意的例外<br />
                    <br />
                    但根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：<br />
                    <br />
                    （1）与国家安全、国防安全有关的；<br />
                    <br />
                    （2）与公共安全、公共卫生、重大公共利益有关的；<br />
                    <br />
                    （3）与犯罪侦查、起诉、审判和判决执行等有关的；<br />
                    <br />
                    （4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；<br />
                    <br />
                    （5）所收集的信息是您自行向社会公众公开的；<br />
                    <br />
                    （6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；<br />
                    <br />
                    （7）根据您的要求签订合同所必需的；<br />
                    <br />
                    （8）用于维护播球帝直播的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br />
                    <br />
                    （9）为合法的新闻报道所必需的；<br />
                    <br />
                    （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；<br />
                    <br />
                    （11）法律法规规定的其他情形。<br />
                    <br />
                    1.2.12有关个人敏感信息的提示<br />
                    <br />
                    以上由您提供或我们收集您的个人信息中，可能包含您的个人敏感信息，例如银行账号、交易信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本隐私政策所述的目的和方式来处理。<br />
                    <br />
                    <br />
                    <br />
                    二、我们如何使用COOKIES或同类技术<br />
                    <br />
                    2.1Cookie 和同类技术是互联网中普遍使用的技术。当您使用播球帝直播及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个COOKIES或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们承诺，不会将COOKIES 用于本隐私政策所述目的之外的任何其他用途。我们使用COOKIES ，可能用于以下用途：<br />
                    <br />
                    （1）记住您的身份。例如：COOKIES或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；<br />
                    <br />
                    （2）分析您使用我们服务的情况。我们可利用COOKIES或同类技术来了解您使用播球帝直播进行什么活动、或哪些服务最受欢迎。<br />
                    <br />
                    2.2您可以通过浏览器或用户选择机制拒绝或管理COOKIES。但请您注意，如果您停用COOKIES，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。<br />
                    <br />
                    <br />
                    <br />
                    三、我们如何共享、转让、公开披露个人信息<br />
                    <br />
                    3.1共享<br />
                    <br />
                    除以下情形外，未经您同意，我们不会与我们之外的任何第三方分享您的个人信息：<br />
                    <br />
                    (1) 向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以实现您需要的核心功能或提供您需要的服务；例如：提供支付服务的支付机构的合作伙伴；<br />
                    <br />
                    (2) 与关联方的必要分享。为便于我们基于统一的帐号体系向您提供一致化服务以及便于您进行统一管理、保障系统和帐号安全等，您的个人信息可能会在我们和我们的关联方之间进行必要共享；<br />
                    <br />
                    (3) 维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们推送通知的通讯服务提供商；<br />
                    <br />
                    (4) 实现本政策第一条“我们如何收集和使用个人信息”部分所述目的；<br />
                    <br />
                    (5) 履行我们在本政策或我们与您达成的其他协议中的义务和行使我们的权利；<br />
                    <br />
                    (6) 在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他播球帝直播用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过,这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。<br />
                    <br />
                    (7) 应您合法需求，协助处理您与他人的纠纷或争议；<br />
                    <br />
                    (8) 应您的监护人合法要求而提供您的个人信息；<br />
                    <br />
                    (9) 根据与您签署的服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br />
                    <br />
                    (10) 基于学术研究而提供；<br />
                    <br />
                    (11) 基于符合法律法规的社会公共利益而提供。<br />
                    <br />
                    我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。<br />
                    <br />
                    3.2转让<br />
                    <br />
                    3.2.1随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。 我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。<br />
                    <br />
                    3.2.2在获得您的明确同意后，我们会向其他方转让您的个人信息。<br />
                    <br />
                    3.3披露
                    <br />
                    我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：<br />
                    <br />
                    1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br />
                    <br />
                    2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。<br />
                    <br />
                    3.4分享、转让、披露信息时事先征得授权同意的例外<br />
                    <br />
                    以下情形中，分享、转让、披露您的个人信息无需事先征得您的授权同意：<br />
                    <br />
                    (1) 与国家安全、国防安全有关的；<br />
                    <br />
                    (2) 与公共安全、公共卫生、重大公共利益有关的；<br />
                    <br />
                    (3) 与犯罪侦查、起诉、审判和判决执行等有关的；<br />
                    <br />
                    (4) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                    <br />
                    (5) 您自行向社会公众公开的信息；<br />
                    <br />
                    (6) 从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道。<br />
                    <br />
                    根据法律规定，分享、转让、披露经去标识化处理的信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。<br />
                    <br />
                    <br />
                    四、我们如何储存和保护个人信息<br />
                    4.1储存个人信息<br />
                    <br />
                    4.1.1储存期限<br />
                    <br />
                    我们仅在为提供服务之目的所必需的期间内保留您的个人信息：您发布的信息、评论、点赞等相关信息，在您未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。<br />
                    <br />
                    4.1.2储存地点<br />
                    <br />
                    我们在中华人民共和国境内运营中收集和产生的个人信息，储存在中国境内，以下情形除外：<br />
                    <br />
                    （1）法律法规有明确规定；<br />
                    <br />
                    （2）获得您的授权同意；<br />
                    <br />
                    （3）您使用的产品、服务涉及跨境，我们需要向境外提供您的个人信息的。<br />
                    <br />
                    针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。<br />
                    <br />
                    4.2保护个人信息<br />
                    <br />
                    4.2.1数据安全技术措施<br />
                    <br />
                    （1）我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。<br />
                    <br />
                    （2）我们的服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。<br />
                    <br />
                    4.2.2其他安全措施
                    <br />
                    （1）我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，要求他们遵守保密义务，并适时对数据和技术进行安全审计。<br />
                    <br />
                    4.2.3安全事件处置
                    <br />
                    （1）为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。<br />
                    <br />
                    （2）在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。<br />
                    <br />
                    请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入播球帝直播所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。<br />
                    <br />
                    请您务必妥善保管好您的账号、密码及其他身份要素。您在使用播球帝直播时，我们会通过您的账号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现账号、密码及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。<br />
                    <br />
                    <br />
                    <br />
                    五、如何管理您的个人信息<br />
                    <br />
                    5.1访问、更新和删除<br />
                    <br />
                    我们鼓励您更新和修改您的个人信息以使其更准确有效。您能通过播球帝直播服务访问您的个人信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的信息或使用播球帝直播时提供的其他信息。<br />
                    <br />
                    在访问、更新、更正和删除前述个人信息时，我们可能会要求您进行身份验证，以保障信息安全。如您想查询、修改或删除您的部分个人信息，请登录播球帝直播进行相关操作，或者通过本隐私政策中载明的联系方式联系我们进行处理。<br />
                    <br />
                    除法律法规另有规定，当您更正、删除您的个人信息或申请注销账号时，我们可能不会立即从备份系统中更正或删除相应的信息，但会在备份更新时更正或删除这些信息。<br />
                    <br />
                    5.2公开与分享<br />
                    <br />
                    我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关个人信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的个人信息。<br />
                    <br />
                    5.3改变您授权同意的范围<br />
                    <br />
                    您总是可以选择是否披露信息。有些信息是使用播球帝直播所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。<br />
                    <br />
                    当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。<br />
                    <br />
                    <br />
                    <br />
                    六、第三方服务<br />
                    6.1播球帝直播可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：<br />
                    <br />
                    6.1.1您可利用“分享”键将播球帝直播中的某些内容分享到第三方。或者，或您可利用第三方服务登录播球帝直播。这些功能可能会收集您的个人信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；<br />
                    <br />
                    6.1.2我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；及<br />
                    <br />
                    6.1.3其他接入第三方服务的情形。<br />
                    <br />
                    例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序服务，并将我们依照本政策收集的您某些信息共享给该等第三方服务商，以便提高更好的客户服务和用户体验。目前，我们接入的第三方服务商的类型及主要目的如下，详见接入第三方SDK目录：<br />
                    <br />
                    （1）第三方SDK“微信”“苹果登录”，为了便于您使用第三方账号进行登录以及分享播球帝直播到第三方平台，需要获取您的IMEI权限和MAC权限及对应信息；<br />
                    <br />
                    （2）第三方SDK“Apple pay”为了便于您在网站或应用程序内进行支付，需要获取您手机的IMEI权限和MAC权限及对应信息；<br />
                    <br />
                    （3）第三方推送服务商-个推，为提高您使用推送的体验，我们接入了多家推送服务商，已使各个手机厂商用户获得良好的使用体验。我们依照本政策收集到您的设备平台、设备厂商、设备品牌、设备识别码（如 IMEI、MAC、IDFA 等）等设备信息，应用列表信息、网络信息（如IP地址、WIFI信息等）以及位置相关信息，将共享给第三方推送服务商，用于为您提供推送技术服务。<br />
                    <br />
                    （4）第三方统计服务商-友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。<br />
                    <br />
                    <br />
                    <br />
                    6.2我们仅会出于正当、必要、特定的目的共享您的信息。对我们与之共享信息的第三方服务商，我们会要求他们履行相关保密义务并采取相应的安全措施。<br />
                    <br />
                    6.3该等接入第三方服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益。<br />
                    <br />
                    <br />
                    七、未成年人保护<br />
                    7.1 我们非常重视对未成年个人信息的保护。根据相关法律法规的规定，若您是未满18周岁的未成年人，在使用播球帝直播及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。<br />
                    <br />
                    7.2 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息；如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。<br />
                    <br />
                    7.3 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策公示的联系方式与我们联系。<br />
                    <br />
                    <br />
                    八、通知和修订<br />
                    （一）我们可能适时修改本政策的条款，该等修改构成本政策的一部分。我们会在播球帝直播内，发出本政策的更新版本或以其他适当方式提醒您相关内容的更新。<br />
                    <br />
                    （二）我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。<br />
                    <br />
                    <br />
                    <br />
                    九、如何联系我们<br />
                    播球帝直播由成都悦谙熙信科技有限公司提供，如果您对个人信息保护问题有投诉、建议、疑问，您可以发送邮件至【boboqiu@yahoo.com】或写信至以下地址：成都市锦江区净局寺路22号1栋2层7号，个人信息保护专员（收），邮编：526000，  我们将在收到您的问题、意见或建议，并验证您的用户身份后的十五个工作日内予以回复。<br />
                    <br />
                    <br />
                </div>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({

}))(PrivacyStatement));